import { useContext, useState } from 'react'
import API from '../../API'
import Context from '../../context'

export function useTest() {

  const {mainState} = useContext(Context)
  const api = new API()

  const [allAnswers, setAllAnswers] = useState({})
  const [testScore, setTestScore] = useState({})
  const [rightObj, setRightObj] = useState({})
  const [scoreQuestions, setScoreQuestions] = useState({})

  function changeAllAnswers(answers, block) {
    setAllAnswers(prev => ({
      ...prev,
      [block]: answers
    }));
  }

  function changeResult(score, id, isRightObj, scoreQuestions) {
    setTestScore(prev => {prev[id] = score; return prev})
    setRightObj(prev => {prev[id] = isRightObj; return prev})
    setScoreQuestions(prev => {prev[id] = scoreQuestions; return prev})
  }

  function sendTest(idTest,statusTest) {
    setTimeout(() => {
    const send = {
      idTest: idTest,
      answers: allAnswers,
      userScore: testScore,
      isRightAnswers: rightObj,
      questionScores: scoreQuestions,
    }
    console.log(send)
    if (mainState.isLoggedIn && mainState.type === "Student") {
      api.sendResult(localStorage.getItem('id'), send) // Демо тест делать без этого запроса
    }    
  }, 1)
  }
  
  return { allAnswers, changeAllAnswers, sendTest, changeResult }
}